import { HtmlRenderer, Parser } from 'commonmark'

import * as React from 'react';
import { Panel, PanelGroup } from 'react-bootstrap';
import { Link } from 'react-router';

import AccordionItem from '../../api/accordionItemEntity';
import ContentPage from '../../api/contentPageEntity';
import LinkItem from '../../api/linkItemEntity';
import VttError from '../../api/vttError';

import { BreadcrumbContainer } from '../../common/components/breadcrumb/breadcrumbContainer';
import { ErrorPage } from '../errorPage';

interface IProps {
    contentPageId: string;
    contentPage: ContentPage;
    errorDescription: VttError;
    route: any;
    fetchContentPageById(id: string): void;
}

export class CommonContentPage extends React.Component<IProps,{previousPath: string}> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            previousPath: ""
        };
      }

    public componentDidMount() {
        let contentPageFriendlyUrl: string;

        if (this.props.contentPageId) {
            contentPageFriendlyUrl = "/" + this.props.contentPageId;
        } else {
            contentPageFriendlyUrl = this.props.route.path;
        }

        this.props.fetchContentPageById(contentPageFriendlyUrl);
    }
  
    public componentWillReceiveProps (nextProps: IProps) {
        let nextContentPageFriendlyUrl: string;

        if (nextProps.contentPageId) {
            nextContentPageFriendlyUrl = "/" + nextProps.contentPageId;
        } else {
            nextContentPageFriendlyUrl = nextProps.route.path;
        }

        if(nextContentPageFriendlyUrl !== this.state.previousPath) {
            // Clean component and reload
            this.props.fetchContentPageById(nextContentPageFriendlyUrl);
        }

        this.setState({
            'previousPath': nextContentPageFriendlyUrl
        })
   }

  public render() {

    if (this.props.errorDescription.hasError) {
        return <ErrorPage message={this.props.errorDescription.message} hasError={true}  />
    }

    const parser = new Parser()
    const renderer = new HtmlRenderer()

    if (this.props.contentPage.isEmpty) {
        return (
            <main className="contentpage">
                <div className="container">
                    <BreadcrumbContainer />
                    <h1>Sisältö ei löytynyt</h1>
                    <p>Ehkä linkki ei toimi? — palaa <Link to={`/`}>etusivulle</Link>.</p>
                    {/* <!-- Tech detail: Contentful query returned no items for /{slug} --> */}
                </div>
            </main>
        );
    }

    const content = renderer.render(parser.parse(this.props.contentPage.content))

    return (
        <main className="contentpage">
            <div className="container">

                <BreadcrumbContainer />

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <img src={this.props.contentPage.heroImage} className="content-hero-img" />
                            <h1>{this.props.contentPage.title}</h1>
                           
                            <p dangerouslySetInnerHTML={ {__html: content} } />
                        <PanelGroup accordion={true} id="accordion">
                            {this.props.contentPage.accordionItems.map(AccordionItemBlock)}
                        </PanelGroup>
                        <div className="row link-blocks">{this.props.contentPage.linkItems.slice(0, 3).map(LinkItemBlock)}</div>
                        <div className="row link-blocks">{this.props.contentPage.linkItems.slice(3, 6).map(LinkItemBlock)}</div>
                    </div>
                </div>
            </div>
        </main>
    );
  }
};

const LinkItemBlock = (linkItem: LinkItem) => {

    if (linkItem.url.startsWith("http")) {
        return (
            <div className="col-md-4">
                <a href={linkItem.url} target={linkItem.urlTarget} className="link-block">
                    <h3>{linkItem.title}</h3>
                    <span>{linkItem.description}</span>
                </a>
            </div>
        )
    }
    
    return (
        <div className="col-md-4">
            <Link to={linkItem.url} className="link-block">
                <h3>{linkItem.title}</h3>
                <span>{linkItem.description}</span>
            </Link>
        </div>
    )
  }

const AccordionItemBlock = (accordionItem: AccordionItem) => {
    const parser = new Parser()
    const renderer = new HtmlRenderer()
    const content = renderer.render(parser.parse(accordionItem.content))

    return (
        <Panel eventKey={accordionItem.id}>
            <Panel.Heading>
                <Panel.Title toggle={true}>{accordionItem.title}</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible={true}>
                <span dangerouslySetInnerHTML={ {__html: content} } />
            </Panel.Body>
        </Panel>
    )
  }


// WEBPACK FOOTER //
// ./src/components/contentPage/contentPage.tsx